module.exports = __webpack_public_path__ + "static/img/fieldman.612af73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fieldman.png
// module id = 309
// module chunks = 6